import React, { useEffect, useState } from 'react';

import { useDispatch } from 'react-redux';

import ConfirmationModal from '../../components/ConfirmationModal';
import DataTable from '../../components/Table/DataTable';
import SearchBox from './../../components/SearchBox/SearchBox';
import AdminModal from '../../components/AdminModal/AdminModal';
import { PlusIcon, TimesCircleIcon, FolderRefreshIcon } from '@stash-ui/regular-icons';

import { showAlert } from '../../store/ducks/alert';
import { CircularProgress } from '@material-ui/core';

import { getPaidSaas, updatePaidSaas, deletePaidSaas, refreshStatusByStripe } from '../../services/paidSaas';
import moment from 'moment';

const PaidSaas = ({ location, match }) => {
  const dispatch = useDispatch();
  const [paidSaas, setPaidSaas] = useState([]);
  const [formData, setFormData] = useState({});
  const [page, setPage] = useState(0);
  const [open, setOpen] = useState(false);
  const [totalPages, setTotalPages] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [isSearching, setIsSearching] = useState(false);
  const [isOrdering, setIsOrdering] = useState(0);
  const [isUpdating, setIsUpdating] = useState(false);
  const [searchField, setSearchField] = useState({
    searchItem: '',
    search: '',
  });
  const [orderDirections, setOrderDirections] = useState({
    item: '',
    direction: '',
  });
  const [currentPaidSaas, setCurrentPaidSaas] = useState({});
  const [isConfirmationDeleteModalOpen, setIsConfirmationDeleteModalOpen] = useState(false);

  useEffect(() => {
    if (location.state && location.state.remount) {
      handleSubmitSearch({
        searchItem: '',
        search: '',
      });
    }
  }, [location]);

  useEffect(() => {
    let currentPage = location.search.split('=')[1] || page;
    if (match && match.params.searchItem && match.params.search) {
      handleSubmitSearch({
        searchItem: match.params.searchItem,
        search: match.params.search,
      });
    }
    displayPaidSaas(currentPage);
  }, [isSearching, isOrdering, page]);

  const handleSubmitSearch = searchBox => {
    setSearchField({
      ...searchField,
      searchItem: searchBox.searchItem,
      search: searchBox.search,
    });
    setIsSearching(searchBox.search);
  };

  const handleCloseModal = () => {
    setFormData({});
    setOpen(false);
  };

  const customActions = [
    {
      icon: <PlusIcon />,
      action: item => {
        handleOpenUpdate(item);
      },
    },
    {
      icon: <TimesCircleIcon />,
      action: item => {
        setIsConfirmationDeleteModalOpen(true);
        setCurrentPaidSaas(item);
      },
    },
    {
      icon: <FolderRefreshIcon />,
      action: item => {
        handleRefreshStatusByStripe(item.id);
      },
    },
  ];

  const handleRefreshStatusByStripe = async paidSaasId => {
    try {
      await refreshStatusByStripe(paidSaasId);
      dispatch(showAlert('success', 'Refreshed! ✅'));
      window.location.reload();
    } catch (error) {
      dispatch(showAlert('error', 'Not possible to refresh. 😔'));
    }
  };

  const handleDeletePaidSaas = async () => {
    try {
      await deletePaidSaas(currentPaidSaas.id);
      dispatch(showAlert('success', 'Deleted! ✅'));
      window.location.reload();
    } catch (error) {
      dispatch(showAlert('error', 'Not possible to delete. 😔'));
    }
  };

  const handleOpenUpdate = async item => {
    setIsUpdating(true);
    setFormData(item);
    console.log('item', item);
    setOpen(true);
  };

  const handleSubmitForm = async dataForm => {
    try {
      const saasPlanId = dataForm.id;
      const data = {
        status: dataForm.status,
        subscriptionToken: dataForm.subscriptionToken,
        nextInvoiceDate: moment(dataForm.nextInvoiceDate).toDate(),
      };
      await updatePaidSaas(saasPlanId, data);

      setIsUpdating(false);

      dispatch(showAlert('success', 'Success! 🔥'));
      window.location = '/paidSaas';
    } catch (error) {
      dispatch(showAlert('error', 'Error! Something went wrong. 😔'));
    }
  };

  const modalColumns = [
    {
      label: 'status',
      prop: 'status',
      type: 'select',
      options: [
        { value: 'ACTIVE', label: 'ACTIVE' },
        { value: 'CANCELED', label: 'CANCELED' },
        { value: 'PAST_DUE', label: 'PAST_DUE' },
        { value: 'TRIALING', label: 'TRIALING' },
      ],
      required: true,
    },
    { label: 'Subscription Token', prop: 'subscriptionToken', type: 'text', required: false },
  ];

  const headers = [
    'id',
    'channelUid',
    'SaasPlansId',
    'status',
    'subscriptionToken',
    'transctionToken',
    'updatedAt',
    'deletedAt',
    'nextInvoiceDate',
  ];

  const SearchBoxHeaders = ['id', 'channelUid', 'SaasPlansId', 'subscriptionToken', 'transctionToken'];

  const displayPaidSaas = async currentPage => {
    try {
      setIsLoading(true);

      let params = { order: orderDirections.item, direction: orderDirections.direction, limit: 5 };
      if (isSearching) params = { ...searchField, ...params };
      const { data: paidSaas } = await getPaidSaas(currentPage || page, params);

      setPaidSaas(paidSaas.rows);
      setTotalItems(paidSaas.count);
      setTotalPages(paidSaas.pages);
      setPage(paidSaas.page);
      setIsLoading(false);
    } catch (error) {
      dispatch(showAlert('error', error.message));
    }
  };

  if (isLoading) return <CircularProgress color="inherit" className="circular-progress" />;

  return (
    <>
      <div className="channels-container">
        <h1>PaidSaas ({totalItems})</h1>
        {open ? (
          <AdminModal
            columns={modalColumns}
            data={formData}
            modalName={'Update PaidSaas'}
            onSubmit={handleSubmitForm}
            onClose={handleCloseModal}
            isUpdating={isUpdating}
          />
        ) : (
          ''
        )}
        <SearchBox
          selectItems={SearchBoxHeaders}
          onSubmitSearch={handleSubmitSearch}
          isSearching={isSearching}
          setIsOrdering={setIsOrdering}
        />
      </div>

      {isConfirmationDeleteModalOpen && (
        <ConfirmationModal
          title={`Are you sure you want to delete this Paid SaaS?`}
          onClose={() => setIsConfirmationDeleteModalOpen(false)}
          onAction={handleDeletePaidSaas}
        />
      )}

      <DataTable
        action={false}
        useUid={true}
        head={headers}
        body={paidSaas}
        customActions={customActions}
        bodyColumn={headers}
        totalPages={totalPages}
        currentPage={page}
        orderDirections={orderDirections}
        setOrderDirections={setOrderDirections}
        setPageChange={setPage}
        setIsOrdering={setIsOrdering}
        isOrdering={isOrdering}
      />
    </>
  );
};

export default PaidSaas;
